// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e1384cd0","879":"9c7741e4"}[chunkId] + ".chunk.js";
};